<template>
   <div class="reward_rule">
      <Delete :delete_message="delete_message" :show="show_delete_modal" @close="$store.commit('show_delete_modal',false)" @delete="deleteRewardRule()"/>

      <Modal :show="show_create_modal" content_class="col-12 col-md-10 col-lg-9 col-xl-8" @close="$store.commit('show_create_modal',false)">
         <template slot="title">
            <div class="title">Add Reward Rules</div>
            <div class="subtitle">Provide the rule details</div>
         </template>
         <template slot="content">
            <div>
               <Wizard 
                  :reset="resetForm"
                  :loading="loading"
                  :forms="[
                     RewardRuleModel.forms.mainDetails,
                     RewardRuleModel.forms.lockRules,
                     RewardRuleModel.forms.otherConfigs,
                  ]"
                  @submit-form="addRewardRule"
               />
            </div>
         </template>
      </Modal>

      <Modal :show="show_edit_modal" content_class="col-12 col-md-10 col-lg-9 col-xl-8" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">Edit Reward Rules</div>
            <div class="subtitle">Provide the rule details</div>
         </template>
         <template slot="content">
            <div>
               <Wizard 
                  :reset="resetForm"
                  :loading="loading"
                  :forms="[
                     RewardRuleModel.forms.mainDetails,
                     RewardRuleModel.forms.lockRules,
                     RewardRuleModel.forms.otherConfigs,
                  ]"
                  @submit-form="updateRewardRule"
               />
            </div>
         </template>
      </Modal>

      <div class="top-actions clearfix">
         <div class="btn btn-primary btn-r" @click="$store.commit('show_create_modal',true)">
            Add Reward Rule <i class="fa fa-plus"></i>
         </div>
      </div>
      
      <Table v-bind="RewardRuleModel.tables.reward_rule.props" :data="reward_rules" @on-action="handleActions">
         <template slot-scope="{ row }" slot="from">
            <strong class="tx-small">{{ dayjs(row.from).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="to">
            <strong class="tx-small">{{ dayjs(row.to).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
      </Table>
   </div>
</template>

<script>
import reward_rule from "./reward_rule.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('reward_rule')
      Event.$off('select-field-changed')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('reward_rule',reward_rule,this.$store)

      Event.$on('select-field-changed',(payload) => {
         this.selectFieldChanged(payload)
      })
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Wizard: () => import("clarks/components/wizard"),
      Table: () => import("clarks/components/ivu-table"),
   },
   data (){
      return {
         dayjs
      };
   },
   computed: {
      ...mapGetters([
         'RewardRuleModel',
         'reward_rules',
         'show_create_modal',
         'show_edit_modal',
         'show_delete_modal',
         'loading',
         'resetForm',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'addRewardRule',
         'deleteRewardRule',
         'selectFieldChanged',
         'updateRewardRule',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('reward_rule',reward_rule,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .reward_rule{
      
   }
</style>